export default __webpack_public_path__ + "static/Ellipse 19-dbe31f76ac4f3606c47fed38de39ced4.png";